var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "url(#pattern0_7761_2273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7761_2273",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7761_2273",
    transform: "matrix(0.0344828 0 0 0.032567 0 -0.0373563)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7761_2273",
    width: 29,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAhCAYAAAAlK6DZAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHaADAAQAAAABAAAAIQAAAAC6qkPWAAAB/ElEQVRIDe1X0W3CMBAlUfhuN4BOUDZoRugvQtCwAUxQmKDtBJFAfJcNyghhgjIC/QfS9yIuch3FjiFQVepJxr7z+T37zpcEbz6fTxqNxjNa7ZKm6Qagq2azOe12uxxn4uP3IoRE9zyvjRbtdrvP2WwW0UYh6VUE5DGi+kiyq5GSDOF+cSbFonG/3/fYgiC4A8AXQaoKw71YLDpOJ8WiRAh4MbCJXBe7rT8cDm0nUhtgxXm3k1YEtboFFo8p8jcp8xkMBqHMMVcI3RJ6S2xlvTG8JkIdsNfrJceHgT5V0I2kBe+aDEZSFHPowoPbfVPF35hThOsdxHlZ+L4/ZhgFGHOvGN9Th28bHZtVjKTY+S0QQkHBRaGeC4g68HmgAX1utw2M4bUtPnX+n/TUyFVa9yfC++P2Vq1L/fgeai3VjWU6SmQLouQ4zw10ynwN9qmxTvWFICRRqNtd9V/L6dp1p+f6M7wjtA8BQt7GSt7E7Nwfn8URsLLHpApQyCkJ8R5dqU6njuM4XuIDLsH6lopx0ZwOh8MtTrxRCVkBFyXFSXnbs1efEDOSAWOPgdj4XnxC7RbykDtUHBAXriGwSZwL/mIkzGn21S1WOEUyPqdXD6LgvDHkvr4TxaHu4RqnnBCUOb1Gnb6BMOQpSRpQwbUeUalbkNfNfr9fCpngfwNt0KSb05LdwwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBible);
export default __webpack_public_path__ + "static/media/bible.46b17d4daeed7960281ca6348d2ca8a4.svg";
export { ForwardRef as ReactComponent };